/**
 * Reads the server's own reason from a failed HTTP call, or returns undefined when there is none.
 *
 * Order: a non-empty string body, then `message` (UserService envelope `{ success, errors[], message }`),
 * then `detail` (older ProblemDetails bodies). A string body starting with `<` is a gateway or proxy
 * HTML page, never a message, so it is skipped. Callers fall back to their own generic text.
 */
export function serverErrorMessage(err: unknown): string | undefined {
  const body = (err as { error?: unknown } | null | undefined)?.error;
  if (typeof body === 'string') {
    const text = body.trim();
    return text && !text.startsWith('<') ? text : undefined;
  }
  const { message, detail } = (body ?? {}) as { message?: unknown; detail?: unknown };
  if (typeof message === 'string' && message.trim()) return message;
  if (typeof detail === 'string' && detail.trim()) return detail;
  return undefined;
}
